import React from "react";


import  './styles/reset.css';
import  './styles/base.css';
import  './styles/colors.css';
import  './styles/line-heigth.css';
import  './styles/font-size.css';
import  './styles/font.css';

import Routes from './routes';
import { Provider } from 'react-redux';
import store from './store';
export default class App extends React.Component {

  async componentDidMount() {
  }

  render() {
    return (
      <Provider store={store} >
        <Routes />
      </Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js